import { Board, BoardType } from "@sportactics/board-editing";
import { createContext } from "react";

import { LazyValue, useLazyContext } from "~utils";

export function useBoardFirestorePersistence(): useBoardFirestorePersistenceReturn {
  return useLazyContext(BoardFirestorePersistenceContext);
}

export type useBoardFirestorePersistenceReturn = {
  upsertBoard: (userId: string, board: Board) => Promise<void>;
  hasBoard: (userId: string, boardType: BoardType) => Promise<boolean>;
  getBoard: (userId: string, boardType: BoardType) => Promise<Board>;
  deleteBoard: (userId: string, boardType: BoardType) => Promise<void>;
};

export const BoardFirestorePersistenceContext =
  createContext<LazyValue<useBoardFirestorePersistenceReturn>>(undefined);
